import { V3_API_URL } from 'views/TradingCompetitionV3/config'
import { CREATE } from 'views/TradingCompetitionV3/routes'
import type { SortKey, TfKey } from './types'

/** Project information API (Django `token_pages`). Defaults to the host of the competition API, so stage and production each talk to their own. */
export const TOKEN_PAGES_API_URL =
  process.env.NEXT_PUBLIC_TOKEN_PAGES_API_URL || V3_API_URL.replace(/\/api\/competitions\/v3\/?$/, '/api/token-pages')

export const TOKEN_CHAIN_ID = 56
export const NATIVE_SYMBOL = 'BNB'

export const TIMEFRAMES: ReadonlyArray<{ key: TfKey; label: string; seconds: number; unit: 'minute' | 'hour' | 'day'; aggregate: number; limit: number }> = [
  { key: '1m', label: '1m', seconds: 60, unit: 'minute', aggregate: 1, limit: 240 },
  { key: '5m', label: '5m', seconds: 300, unit: 'minute', aggregate: 5, limit: 288 },
  { key: '15m', label: '15m', seconds: 900, unit: 'minute', aggregate: 15, limit: 288 },
  { key: '1h', label: '1h', seconds: 3600, unit: 'hour', aggregate: 1, limit: 336 },
  { key: '4h', label: '4h', seconds: 14400, unit: 'hour', aggregate: 4, limit: 360 },
  { key: '1d', label: 'D', seconds: 86400, unit: 'day', aggregate: 1, limit: 365 },
]
export const DEFAULT_TF: TfKey = '15m'
export const isTf = (v: unknown): v is TfKey => TIMEFRAMES.some((t) => t.key === v)
export const tfOf = (k: TfKey) => TIMEFRAMES.find((t) => t.key === k) as (typeof TIMEFRAMES)[number]

export const SORTS: ReadonlyArray<{ key: SortKey; label: string }> = [
  { key: 'hot', label: 'Hot on CADINUdex' },
  { key: 'liquidity', label: 'Liquidity' },
  { key: 'mcap', label: 'Market cap' },
  { key: 'competitions', label: 'Most competitions' },
]
export const isSort = (v: unknown): v is SortKey => SORTS.some((s) => s.key === v)

export const tokenHref = (address: string) => `/token/${address}`
export const submitHref = (address: string) => `/token/${address}/submit`
export const createCompetitionHref = (address: string, pool?: string) =>
  `${CREATE}?token=${address}${pool ? `&pool=${pool}` : ''}`

/** How many of a token's strongest pools "All pools" reads for the trade history: each Gecko-indexed pool is a call on a shared free budget (30 per minute for the whole server). */
export const ALL_POOLS = 3
